import React from 'react';
import CountryDetail from '../components/CountryDetail';

const Details = () => {
    return (
        <>
            <CountryDetail/>
        </>
    )
}

export default Details
